/* eslint-disable react/no-unknown-property */
import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Modal, Form } from "react-bootstrap";
import { Button } from "reactstrap";

const AddBroker = ({ show, handleClose, formik, t, submitting, isEdit }) => {
  return (
    <Modal
      size="md"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? t("Edit Broker") : t("Add Broker")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-12">
              <Form.Group className="mb-3" controlId="companyName">
                <Form.Label>{t("Company Name")}</Form.Label>
                <Form.Control
                  type="text"
                  name="companyName"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.companyName}
                  placeholder=""
                />
                {formik.touched.companyName && formik.errors.companyName ? (
                  <div style={{ color: "red" }}>{formik.errors.companyName}</div>
                ) : null}
              </Form.Group>
            </div>
            <div className="col-12">
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>{t("Email")}</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  placeholder=""
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red" }}>{formik.errors.email}</div>
                ) : null}
              </Form.Group>
            </div>
            <div className="col-12">
              <Form.Group className="mb-3" controlId="phoneNumber">
                <Form.Label>{t("Phone Number")}</Form.Label>
                <Form.Control
                  type="text"
                  name="phoneNumber"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phoneNumber}
                  placeholder=""
                />
                {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                  <div style={{ color: "red" }}>{formik.errors.phoneNumber}</div>
                ) : null}
              </Form.Group>
            </div>
            <div className="col-12">
              <Form.Group className="mb-3" controlId="officeAddress">
                <Form.Label>{t("Office Address")}</Form.Label>
                <Form.Control
                  type="text"
                  name="officeAddress"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.officeAddress}
                  placeholder=""
                />
                {formik.touched.officeAddress && formik.errors.officeAddress ? (
                  <div style={{ color: "red" }}>{formik.errors.officeAddress}</div>
                ) : null}
              </Form.Group>
            </div>
          </div>
          <div className="text-end">
            <Button
              disabled={submitting}
              type="submit"
              variant="primary"
              className="all-common-btn mx-1"
              style={{ marginLeft: 10 }}
            >
              {isEdit ? t("Update") : t("Submit")}
            </Button>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

AddBroker.propTypes = {
  t: PropTypes.any,
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  formik: PropTypes.any,
  submitting: PropTypes.bool,
  isEdit: PropTypes.bool,
};

export default withRouter(withTranslation()(AddBroker));


